import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import { Outlet } from "react-router-dom"

import Column from "../../common/components/Column"
import Row from "../../common/components/Row"
import handshakeImage from "../../static/images/admin-login-handshake.png"
import onebaseLogo from "../../static/images/onebase-logo.png"
import { adminLayoutBackgroundSx, adminPageSx } from "./adminStyles"

function AdminAuthBrandHeader() {
  return (
    <Column
      sx={{ mb: 4, alignItems: "center", gap: 1.25, textAlign: "center" }}
    >
      <Row sx={{ alignItems: "center", justifyContent: "center", gap: 1.5 }}>
        <Box
          component="img"
          src={onebaseLogo}
          alt="OneBase logo"
          sx={{ height: 44 }}
        />
        <Row sx={{ alignItems: "baseline", gap: 0.75 }}>
          <Typography
            sx={{
              fontFamily: "Montserrat, sans-serif",
              fontSize: { xs: 26, sm: 30 },
              fontWeight: 700,
              lineHeight: 1,
            }}
          >
            <Box component="span" sx={{ color: "#FE35CF" }}>
              One
            </Box>
            <Box component="span" sx={{ color: "#8A35D0" }}>
              Base
            </Box>
          </Typography>
          <Typography
            sx={{
              fontFamily: "Montserrat, sans-serif",
              fontSize: { xs: 20, sm: 24 },
              fontWeight: 700,
              lineHeight: 1,
              color: "#8A35D0",
            }}
          >
            Admin
          </Typography>
        </Row>
      </Row>
    </Column>
  )
}

export default function AdminAuthLayout() {
  return (
    <Row sx={{ minHeight: "100vh", width: "100%", ...adminLayoutBackgroundSx }}>
      <Box
        sx={{
          display: { xs: "none", md: "block" },
          flex: 1,
          position: "relative",
          overflow: "hidden",
          bgcolor: "#F5F6FA",
        }}
      >
        <Box
          component="img"
          src={handshakeImage}
          alt="Two professionals shaking hands"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(135deg, rgba(147, 32, 213, 0.72) 0%, rgba(138, 53, 208, 0.55) 45%, rgba(254, 53, 207, 0.35) 100%)",
          }}
        />
      </Box>

      <Column
        sx={{
          flex: { xs: 1, md: "0 0 480px", lg: "0 0 520px" },
          minHeight: "100vh",
          justifyContent: "center",
          alignItems: "center",
          px: { xs: 3, sm: 6 },
          py: 4,
          bgcolor: "background.paper",
          boxShadow: { md: "-8px 0 32px rgba(10, 37, 64, 0.08)" },
          fontFamily: "Inter, sans-serif",
          ...adminPageSx,
          backdropFilter: "blur(21px)",
          background:
            "linear-gradient(159deg, rgba(255, 255, 255, 0.92) 3%, rgba(255, 255, 255, 0.78) 100%)",
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: 380,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <AdminAuthBrandHeader />
          <Outlet />
        </Box>
      </Column>
    </Row>
  )
}
